<template>
  <el-card
    style="height: 100%"
    shadow="always"
    v-loading="loading"
    :body-style="{ padding: '0px' }"
  >
    <div class="row p-3">
      <div class="col-12 d-flex align-items-center justify-content-between">
        <h1 class="text-navy">Statements</h1>
        <el-button @click="showStatementModal()" class="btn-primary">
          New Statement
        </el-button>
      </div>
      <div class="col-12 d-none d-lg-block">
        <el-table :data="statements.data">
          <el-table-column label="Date Created" prop="created_at">
            <template slot-scope="scope">
              {{ moment(scope.row.created_at).format("DD/MM/YYYY") }}
            </template>
          </el-table-column>
          <el-table-column label="Statement Date">
            <template slot-scope="scope">
              {{
                moment(scope.row.date)
                  .tz("Australia/Brisbane")
                  .format("DD/MM/YYYY")
              }}
            </template>
          </el-table-column>
          <el-table-column
            label="Name"
            prop="name"
            width="300"
          ></el-table-column>
          <el-table-column label="Statement Type" prop="is_group">
            <template slot-scope="scope">
              {{
                scope.row.is_group ? "Group Statement" : "Individual Statement"
              }}
            </template>
          </el-table-column>
          <el-table-column label="Actions" prop="id">
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                content="Generating Statement"
                placement="bottom"
                v-if="scope.row.loading"
              >
                <i class="el-icon el-icon-loading font-20"></i>
              </el-tooltip>
              <div v-else>
                <a
                  v-if="scope.row.url"
                  class="has-interaction text-green mr-2"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="View"
                  :href="scope.row.url"
                  target="_blank"
                >
                  <i class="far fa-globe fa-lg"></i>
                </a>
                <a
                  v-if="scope.row.media.length"
                  class="has-interaction text-green mr-2"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Edit"
                  :href="scope.row.media[0].url"
                  target="_blank"
                >
                  <i class="far fa-eye fa-lg"></i>
                </a>
                <a
                  v-if="scope.row.media.length"
                  :href="`${scope.row.media[0].download_url}`"
                  class="has-interaction text-blue mr-2"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Download File"
                >
                  <i class="far fa-download fa-lg"></i>
                </a>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="col-12 d-lg-none">
        <el-table :data="statements.data">
          <el-table-column label="Statement Date" width="100px">
            <template slot-scope="scope">
              {{
                moment(scope.row.date)
                  .tz("Australia/Brisbane")
                  .format("DD/MM/YYYY")
              }}
            </template>
          </el-table-column>
          <el-table-column label="Name" prop="name"></el-table-column>
          <el-table-column label="Actions" prop="id" width="130px">
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                content="Generating Statement"
                placement="bottom"
                v-if="scope.row.loading"
              >
                <i class="el-icon el-icon-loading font-20"></i>
              </el-tooltip>
              <div v-else>
                <a
                  v-if="scope.row.url"
                  class="has-interaction text-green mr-2"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="View"
                  :href="scope.row.url"
                  target="_blank"
                >
                  <i class="far fa-globe fa-lg"></i>
                </a>
                <a
                  v-if="scope.row.media.length"
                  class="has-interaction text-green mr-2"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Edit"
                  :href="scope.row.media[0].url"
                  target="_blank"
                >
                  <i class="far fa-eye fa-lg"></i>
                </a>
                <a
                  v-if="scope.row.media.length"
                  :href="scope.row.media[0].download_url"
                  class="has-interaction text-blue mr-2"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Download File"
                >
                  <i class="far fa-download fa-lg"></i>
                </a>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div
        class="col-12 py-3 d-flex justify-content-center justify-content-xl-end"
      >
        <el-pagination
          small
          layout="prev, pager, next, total"
          :current-page.sync="currentPage"
          @current-change="handleCurrentChange"
          :background="true"
          :page-size="perPage"
          :page-count="statements.last_page"
          :total="statements.total"
        />
      </div>
    </div>
    <group-statement-generation
      :initial_business_id="business.id"
      v-if="statementModalShow"
      @close="
        statementModalShow = false;
        getStatements;
      "
      :statement-type-group="true"
    ></group-statement-generation>
  </el-card>
</template>
<script>
import Statement from "../../../modelsPortal/Statement";
import Business from "../../../modelsPortal/Business";
import GroupStatementGeneration from "../../business/modals/GroupStatementGeneration.vue";
export default {
  components: { GroupStatementGeneration },
  props: {
    initial_business: {
      type: Object,
    },
    isProducer: {
      type: Number,
    },
  },
  data() {
    return {
      business: this.initial_business,
      statements: [],
      loading: false,
      statementModalShow: false,
      page: 1,
      currentPage: 1,
      perPage: 5,
    };
  },
  mounted() {
    this.getStatements();
  },
  methods: {
    getStatements(page = 1) {
      this.statementModalShow = false;
      this.loading = true;
      let self = this;

      let statements = Statement.page(page)
        .where("business_id", this.business.id)
        .select(
          "id",
          "created_at",
          "business_id",
          "purchase_id",
          "date",
          "is_group",
          "url",
          "name",
          "created_at",
        )
        .orderBy("-created_at")
        .include("business,media")
        .params({ per_page: this.perPage });

      statements
        .get()
        .then((res) => {
          this.loading = false;
          this.statements = res;
          this.currentPage = page;
          self.generationStatement();
        })
        .catch((errors) => {
          console.log(errors);
          this.loading = false;
          this.$message({
            type: "error",
            message: "Looks like something went wrong.",
          });
        });
    },
    handleCurrentChange(page = 1) {
      this.getStatements(page);
    },
    showStatementModal() {
      this.statementModalShow = true;
    },
    generationStatement() {
      this.statements.data.forEach((statement, index) => {
        let date = moment
          .utc(statement.created_at, "YYYY-MM-DD HH:mm:ss")
          .local()
          .add(1, "minutes");
        statement.loading = moment().isBefore(date) ? true : false;
        this.$set(this.statements.data, index, statement);
      });

      setTimeout(() => {
        this.statements.data = this.statements.data.map((p) => ({
          ...p,
          loading: false,
        }));
      }, 60000);
    },
  },
};
</script>
